export default __webpack_public_path__ + "static/media/bb-00004.89f9bb26.png";